import {
    useHistory,
} from 'react-router-dom';

import { PROJECT_PREFIX } from '../const';
import { useUser } from '../contexts/user';

const AuthCheck = () => {
    const { user } = useUser();
    const history = useHistory();

    const isAuthPage = window.location.pathname.includes('/auth');

    if (user?.otp_passed === false && !isAuthPage) {
        history.push(`${PROJECT_PREFIX}/auth/`);
    }

    return null;
};

export default AuthCheck;
